import { GQLContentForm } from "@quales/data-access/graphql";
import lodash from "lodash";
import { GetFormSchemaPath } from "./GetFormSchemaPath";
import { GetUISchemaPath } from "./GetUISchemaPath";
import { nanoid } from "nanoid";
import { GetFormSchemaItem } from "./GetFormSchemaItem";
import { SetUiOrderForNewItem } from "./SetUiOrderForNewItem";

export const GetNewItemAdded = (
  node: any,
  type: string,
  formContent: GQLContentForm
) => {
  const currentFormContent = lodash.cloneDeep(formContent.formSchema);
  const getSchemaPath = GetFormSchemaPath(node.id, formContent);
  const getUISchemaPath = GetUISchemaPath(getSchemaPath);
  const itemID = nanoid(6);

  if (
    formContent &&
    formContent.formSchema &&
    Object.hasOwn(formContent.formSchema, "properties")
  ) {
    if (type === "text") {
      if (node.id === "root") {
        const textField = {
          title: "New Textfield",

          type: "string",
        };
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `textfield_${itemID}`,
          formContent
        );
        currentFormContent.properties[`textfield_${itemID}`] = textField;
        return {
          formSchema: { ...currentFormContent },
          type: type,
          uiSchema: { ...getUiOptions },
        };
      } else {
        const findItemPath = GetFormSchemaPath(node.id, formContent);
        const findItem = GetFormSchemaItem(node.id, formContent);

        const textField = {
          title: "New Textfield",

          type: "string",
        };

        findItem.properties = {
          ...findItem.properties,
          [`textfield_${itemID}`]: textField,
        };

        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `textfield_${itemID}`,
          formContent
        );

        lodash.set(currentFormContent, findItemPath, {
          ...findItem,
        });
        return {
          formSchema: currentFormContent,
          type: type,
          uiSchema: { ...getUiOptions },
        };
      }
    } else if (type === "object") {
      if (node.id === "root") {
        const object = {
          title: "Object",
          properties: {},
          type: "object",
        };

        currentFormContent.properties[`object_${itemID}`] = object;
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `object_${itemID}`,
          formContent
        );

        lodash.set(getUiOptions, `${getUISchemaPath}${`object_${itemID}`}`, {
          "ui:options": {
            fullWidth: true,
          },
        });

        return {
          formSchema: { ...currentFormContent },
          type: type,
          uiSchema: { ...getUiOptions },
        };
      } else {
        const findItemPath = GetFormSchemaPath(node.id, formContent);
        const findItem = GetFormSchemaItem(node.id, formContent);

        const object = {
          title: "Object",
          properties: {},
          type: "object",
        };
        findItem.properties = {
          ...findItem.properties,
          [`object_${itemID}`]: object,
        };
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,

          `object_${itemID}`,
          formContent
        );

        lodash.set(currentFormContent, findItemPath, {
          ...findItem,
        });

        lodash.set(getUiOptions, `${getUISchemaPath}.${`object_${itemID}`}`, {
          "ui:options": {
            fullWidth: true,
          },
        });

        return {
          uiSchema: { ...getUiOptions },
          type: type,
          formSchema: currentFormContent,
        };
      }
    } else if (type === "array") {
      if (node.id === "root") {
        const array = {
          title: "Array",
          uniqueItems: true,
          items: { enum: [], type: "string" },
          type: "array",
        };

        currentFormContent.properties[`array_${itemID}`] = array;
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `array_${itemID}`,
          formContent
        );
        return {
          formSchema: { ...currentFormContent },
          type: type,
          uiSchema: { ...getUiOptions },
        };
      } else {
        const findItemPath = GetFormSchemaPath(node.id, formContent);
        const findItem = GetFormSchemaItem(node.id, formContent);

        const array = {
          title: "Array",
          items: { enum: [], type: "string" },
          type: "array",
          uniqueItems: true,
        };
        findItem.properties = {
          ...findItem.properties,
          [`array_${itemID}`]: array,
        };
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,

          `array_${itemID}`,
          formContent
        );

        lodash.set(currentFormContent, findItemPath, {
          ...findItem,
        });

        return {
          uiSchema: { ...getUiOptions },
          type: type,
          formSchema: currentFormContent,
        };
      }
    } else if (type === "image") {
      if (node.id === "root") {
        const image = {
          items: {
            properties: {
              date: {
                type: "string",
              },
              description: {
                type: "string",
              },
              fileName: {
                type: "string",
              },
            },
            type: "object",
          },
          title: "Foto's",
          type: "array",
        };
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `image_${itemID}`,
          formContent
        );
        currentFormContent.properties[`image_${itemID}`] = image;
        lodash.set(getUiOptions, `${getUISchemaPath}${`image_${itemID}`}`, {
          "ui:field": "ImageUploadField",
          "ui:options": {
            fullWidth: true,
          },
        });
        return {
          type: type,
          formSchema: { ...currentFormContent },
          uiSchema: { ...getUiOptions },
        };
      } else {
        const findItemPath = GetFormSchemaPath(node.id, formContent);
        const findItem = GetFormSchemaItem(node.id, formContent);

        const image = {
          items: {
            properties: {
              date: {
                type: "string",
              },
              description: {
                type: "string",
              },
              fileName: {
                type: "string",
              },
            },
            type: "object",
          },
          title: "Foto's",
          type: "array",
        };

        findItem.properties = {
          ...findItem.properties,
          [`image_${itemID}`]: image,
        };

        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `image_${itemID}`,
          formContent
        );

        lodash.set(getUiOptions, `${getUISchemaPath}.${`image_${itemID}`}`, {
          "ui:field": "ImageUploadField",
          "ui:options": {
            fullWidth: true,
          },
        });

        lodash.set(currentFormContent, findItemPath, {
          ...findItem,
        });

        return {
          formSchema: currentFormContent,
          type: type,
          uiSchema: { ...getUiOptions },
        };
      }
    } else if (type === "signature") {
      if (node.id === "root") {
        const image = {
          items: {
            properties: {
              date: {
                type: "string",
              },
              author: {
                type: "string",
              },
              fileName: {
                type: "string",
              },
            },
            type: "object",
          },
          title: "Handtekening",
          type: "array",
        };
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `signature_${itemID}`,
          formContent
        );
        currentFormContent.properties[`signature_${itemID}`] = image;
        lodash.set(getUiOptions, `${getUISchemaPath}${`signature_${itemID}`}`, {
          "ui:field": "SignatureField",
          "ui:options": {
            fullWidth: true,
          },
        });
        return {
          type: type,
          formSchema: { ...currentFormContent },
          uiSchema: { ...getUiOptions },
        };
      } else {
        const findItemPath = GetFormSchemaPath(node.id, formContent);
        const findItem = GetFormSchemaItem(node.id, formContent);

        const image = {
          items: {
            properties: {
              date: {
                type: "string",
              },
              author: {
                type: "string",
              },
              fileName: {
                type: "string",
              },
            },
            type: "object",
          },
          title: "Handtekening",
          type: "array",
        };

        findItem.properties = {
          ...findItem.properties,
          [`signature_${itemID}`]: image,
        };

        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `signature_${itemID}`,
          formContent
        );

        lodash.set(
          getUiOptions,
          `${getUISchemaPath}.${`signature_${itemID}`}`,
          {
            "ui:field": "SignatureField",
            "ui:options": {
              fullWidth: true,
            },
          }
        );

        lodash.set(currentFormContent, findItemPath, {
          ...findItem,
        });

        return {
          formSchema: currentFormContent,
          type: type,
          uiSchema: { ...getUiOptions },
        };
      }
    } else if (type === "listOfStrings") {
      if (node.id === "root") {
        const array = {
          title: " Strings Array",
          items: { type: "string" },
          type: "array",
        };

        currentFormContent.properties[`array_${itemID}`] = array;
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `array_${itemID}`,
          formContent
        );

        return {
          formSchema: { ...currentFormContent },
          type: type,
          uiSchema: { ...getUiOptions },
        };
      } else {
        const findItemPath = GetFormSchemaPath(node.id, formContent);
        const findItem = GetFormSchemaItem(node.id, formContent);

        const array = {
          title: " Strings Array",
          items: { type: "string" },
          type: "array",
        };
        findItem.properties = {
          ...findItem.properties,
          [`array_${itemID}`]: array,
        };
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,

          `array_${itemID}`,
          formContent
        );

        lodash.set(currentFormContent, findItemPath, {
          ...findItem,
        });

        return {
          uiSchema: { ...getUiOptions },
          type: type,
          formSchema: currentFormContent,
        };
      }
    } else {
      if (node.id === "root") {
        const boolean = {
          title: "Checkbox",
          type: "boolean",
        };

        currentFormContent.properties[`checkbox_${itemID}`] = boolean;
        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `checkbox_${itemID}`,
          formContent
        );

        return {
          formSchema: { ...currentFormContent },
          type: type,
          uiSchema: { ...getUiOptions },
        };
      } else {
        const findItemPath = GetFormSchemaPath(node.id, formContent);
        const findItem = GetFormSchemaItem(node.id, formContent);

        const boolean = {
          title: "Checkbox",
          type: "boolean",
        };
        findItem.properties = {
          ...findItem.properties,
          [`checkbox_${itemID}`]: boolean,
        };

        const getUiOptions = SetUiOrderForNewItem(
          getUISchemaPath,
          `checkbox_${itemID}`,
          formContent
        );

        lodash.set(currentFormContent, findItemPath, {
          ...findItem,
        });

        return {
          formSchema: currentFormContent,
          type: type,
          uiSchema: { ...getUiOptions },
        };
      }
    }
  } else {
    if (type === "text") {
      const newFormContent = {
        title: "A form",
        description: "A form description.",
        type: "object",
        properties: {},
      };

      const textField = {
        title: "New Textfield",
        type: "string",
      };

      newFormContent.properties[`textfield_${itemID}`] = textField;

      return {
        formSchema: { ...newFormContent },
        type: type,
        uiSchema: { "ui:order": [`textfield_${itemID}`] },
      };
    } else if (type === "object") {
      const newFormContent = {
        title: "A form",
        description: "A form description.",
        type: "object",
        properties: {},
      };

      const object = {
        title: "Object",
        description: "",
        type: "object",
        properties: {},
      };

      newFormContent.properties[`object_${itemID}`] = object;

      return {
        formSchema: { ...newFormContent },
        type: type,
        uiSchema: { "ui:order": [`object_${itemID}`] },
      };
    } else if (type === "array") {
      const newFormContent = {
        title: "A form",
        description: "A form description.",
        type: "object",
        properties: {},
      };

      const array = {
        title: "Array",
        uniqueItems: true,
        items: { enum: [], type: "string" },
        type: "array",
      };

      newFormContent.properties[`array_${itemID}`] = array;

      return {
        formSchema: { ...newFormContent },
        type: type,
        uiSchema: { "ui:order": [`array_${itemID}`] },
      };
    } else {
      const newFormContent = {
        title: "A form",
        description: "A form description.",
        type: "object",
        properties: {},
      };

      const boolean = {
        title: "Checkbox",
        type: "boolean",
      };

      newFormContent.properties[`checkbox_${itemID}`] = boolean;

      return {
        formSchema: { ...newFormContent },
        type: type,
        uiSchema: { "ui:order": [`checkbox_${itemID}`] },
      };
    }
  }
};
